import { render, staticRenderFns } from "./ContactReportsReviewFilters.vue?vue&type=template&id=20a430cf"
import script from "./ContactReportsReviewFilters.vue?vue&type=script&lang=js"
export * from "./ContactReportsReviewFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports